
import { NOTIFICATION_SOUNDS } from '../utils/monitor/monitor.utils.ValueSets';

const PlayNotifSound = (notificationSound) => {
    const { sound } = NOTIFICATION_SOUNDS.filter((s) => s.id === notificationSound)[0];
    const audioElement = new Audio(sound);
    audioElement.play();
}

export default PlayNotifSound;